import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
interface Option {
  label: string;
  value: string;
  data?: any;
}
interface DropdownOptionProps {
  name?: string;
  initialValue?: Option | undefined | null;
  dataList?: Option[];
  onChangeSelect?: (params: Option) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  classNamePrefix?: string;
  isHasOptionAll?: boolean;
  optionAll?: undefined | Option;
  labelTop?: string;
  isMultiLang?: boolean;
  isHaveMore?: boolean
}

const DropdownOption = ({
  name = "",
  initialValue,
  onChangeSelect,
  dataList = [],
  placeholder,
  disabled = false,
  className = "",
  classNamePrefix = "",
  isHasOptionAll = false,
  optionAll,
  labelTop = "",
  isMultiLang = false,
  isHaveMore = false
}: DropdownOptionProps) => {
  const { t, i18n } = useTranslation();
  const [options, setOptions] = useState<Option[]>([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  useEffect(() => {
    const resultOptions =
      dataList?.map((item) => ({
        ...(isHaveMore ? item?.data : {}),
        label: item?.label,
        value: String(item?.value || ""),
      })) || ([] as Option[]);
    const result: any = isHasOptionAll
      ? [optionAll].concat(resultOptions)
      : resultOptions;
    setOptions((_prev: any) => result);

    if (initialValue && initialValue?.value) {
      const val = result?.filter(
        (e: any) => e.value === initialValue?.value
      )[0];
      setOnChangeOption(val);
    } else {
      setOnChangeOption(isHasOptionAll ? result[0] : null);
    }
  }, [JSON.stringify(dataList), JSON.stringify(initialValue), i18n?.language]);

  return (
    <div className="position-relative">
      <Select
        options={options}
        value={initialValue}
        name={name}
        isDisabled={disabled}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{placeholder || ""}</div>}
        loadingMessage={() => <div>{t("Loading")}...</div>}
        noOptionsMessage={() => <div>{t("No Options")}</div>}
        className={className}
        classNamePrefix={classNamePrefix}
        isClearable={false}
      />
      {labelTop && (
        <label
          style={{
            position: "absolute",
            left: "5px",
            top: "0px",
            marginBottom: "0px",
            transform: "translateY(-50%)",
            padding: `0px 5px`,
            color: "#c2c2c2",
            fontSize: "12px",
            fontWeight: "400",
            borderRadius: "3px",
            backgroundColor: disabled
              ? "hsl(0, 0%, 95%)"
              : "var(--vz-secondary-bg)",
          }}
        >
          {isMultiLang ? t(labelTop) : labelTop}
        </label>
      )}
    </div>
  );
};

export default DropdownOption;
